import {
  Paper as MuiPaper,
  Typography as MuiTypography,
  Box as MuiBox,
  Chip as MuiChip,
} from "@mui/material";

const StudyStatusCard = ({ Icon, count, label, status, color }) => {
  return (
    <MuiPaper
      variant="outlined"
      sx={{
        p: 3,
        display: "flex",
        alignItems: "center",
        gap: 2,
        borderRadius: 3,
        width: "100%",
        height: "100%",
      }}
    >
      {/* Icon Circle */}
      <MuiBox
        sx={{
          width: 45,
          height: 45,
          borderRadius: "50%",
          border: "1px solid #dfdfdf",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon sx={{ fontSize: 22, color: "text.primary" }} />
      </MuiBox>

      {/* Text Content */}
      <MuiBox>
        <MuiTypography variant="h6" sx={{ fontSize: "18px", fontWeight: 600 }}>
          {count} {label}
        </MuiTypography>

        <MuiChip
          label={status}
          size="small"
          sx={{
            mt: 1,
            backgroundColor: color.bg,
            color: color.text,
            fontWeight: 500,
            borderRadius: "999px",
          }}
        />
      </MuiBox>
    </MuiPaper>
  );
};

export default StudyStatusCard;
